<template>
  <div>
    <div class="table_scrol">
      <div class="w-card__content content-hardcode mb3">
         <div class="form-row">
           <div class="form-col">
             <w-select
               class="mt4"
               :items="negeri"
               item-value="id"
               item-label="nama"
               label="Negeri"
               v-model="carian.lkp_negeri_id"
               @input="getPremis(carian.lkp_negeri_id)"
             />
           </div>

           <div class="form-col">
             <w-select
               class="mt4"
               :items="premis"
               item-value="id"
               item-label="nama"
               label="Premis"
               v-model="carian.premis_id"
               @input="getData"
             />
           </div>

           <div class="form-col">
             <w-select
               class="mt4"
               :items="senarai_tahun"
               label="Tahun"
               v-model="carian.tahun"
               @input="getData"
             />
           </div>
         </div>
        <div class="cards-table-grid">
          <div class="dashboard-grid">
              <div
                v-for="(card, index) in cards2"
                :key="index"
                class="card-box"
                @click="openDialog(index)"
              >
                <div class="card-content">
                  <div class="card-text">
                    <h2 class="card-value">{{ formatNumber(card.jumlah) }}</h2>
                    <small 
                      class="card-subtitle" 
                      :class="[
                        'sub' + (index + 1), 
                        { 'with-highlight': !['Jumlah Stok Semen', 'Purata Kebuntingan AI'].includes(card.keterangan) }
                      ]"
                    >
                      {{ card.keterangan }}
                    </small>
                  </div>
                  <div class="card-icon" :class="'bg' + (index + 1)">
                    <img src="/images/chart1.png" alt="chart" class="icon-img" />
                  </div>
                </div>
              </div>
            </div>

          <div class="tables-stack" v-if="!$zutil.role('14')">
            <div class="w-table-wrap modern-table" style="max-height: 400px;">
              <div class="table-profil-scrol">
                   <table class="w-table w-100">
                  <thead>
                    <tr class="table-header">
                      <th colspan="3" class="text-center">
                        <div class="header-column">
                          <span class="title">TUGASAN</span>
                          <span class="datetime">
                            📅 {{ currentDate }} | 🕒 {{ currentTime }}
                          </span>
                        </div>
                      </th>
                    </tr>
                    <tr class="table-subheader">
                      <th class="text-center">Tugas</th>
                      <th class="text-center">Tarikh Terima Tugasan</th>
                      <th class="text-center">Bilangan</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in tarikh_aiman" :key="index">
                      <td class="text-center">{{ row.Tugas }}</td>
                      <td class="text-center">{{ row.Tarikh }}</td>
                      <td class="text-center">
                      <button class="btn-modern" @click="tugas(row)">
                          {{ row.Bilangan }}
                        </button>

                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="trend-grid">
          <div class="trend-box">
             <w-select
                class="mt4" 
                v-model="carian_tahun.bulan_tahun" 
                :items="bulan_tahun"
                @input="getServis()" 
              />
            <GChart
              type="LineChart"
              :data="d_servis.datas"
              :options="{
                title: 'Jumlah Servis AI',
                curveType: 'function',
                legend: { position: 'bottom' },
                chartArea: { left: 50, right: 20, top: 40, bottom: 60 },
                vAxis: {
                 viewWindow: {
                   min: 0
                 },
                 format: '0', 
               },
               series: {
                      0: { color: '#ef4444' } 
                    },
                tooltip: { isHtml: true }
              }"
            />
          </div>

          <div class="trend-box">
             <w-select
                class="mt4" 
                v-model="carian_bulan.bulan_tahun" 
                :items="bulan_tahun" 
                @input="getAnak()" 
              />
            <GChart
              type="LineChart"
              :data="d_anak.datas"
              :options="{
                title: 'Jumlah Kelahiran Anak AI',
                curveType: 'function',
                legend: { position: 'bottom' },
                chartArea: { left: 50, right: 20, top: 40, bottom: 60 },
                vAxis: {
                       viewWindow: {
                         min: 0
                       },
                       format: '0', 
                   },
                   series: {
                      0: { color: '#06b6d4' } 
                    },
                tooltip: { isHtml: true }
              }"
            />
          </div>
        </div>
      </div>
    </div>

    <w-dialog
      v-model="dialog.show"
      :fullscreen="true"
      :width="dialogWidth"
      :max-width="dialogMaxWidth"
      :persistent="dialog.persistent"
      :persistent-no-animation="dialog.persistentNoAnimation"
      title-class="primary-dark1--bg white"
      content-class="dialog-content-custom"
    >
      <template #title>
        Jumlah Ternakan
      </template>

      <w-select
           class="mt4"
           outline
           :items="lkp_ternakanWithAll"  
           item-value="value"       
           item-label="label"      
           label="Jenis Ternakan *"
           v-model="selectedTernakanId"
           @input="Chart(lastItemData)"
           :loading="isLoadingTernakan"
         />

      <div class="chart-grid" :class="{ 'chart-grid-mobile': isMobile }">
        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartTernakan" 
            :options="getChartOptions('Jenis Ternakan')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartJantina" 
            :options="getChartOptions('Jantina')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartBaka" 
            :options="getChartOptions('Baka')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartJurusan" 
            :options="getChartOptions('Jurusan')"
          />
        </div>

        <div class="chart-box-full">
              <!-- Keterangan warna khusus untuk chart umur -->
              <div class="chart-umur-legend">
               <div class="legend-dot-item">
                  <span class="dot male-dot">●</span>
                  <span class="legend-label">Jantan</span>
                </div>
                <div class="legend-dot-item">
                  <span class="dot female-dot">●</span>
                  <span class="legend-label">Betina</span>
                </div>
              </div>
              
              <GChart 
                type="ColumnChart" 
                :data="chartUmur" 
                :options="getUmurChartOptions()"
              />
            </div>
      </div>

      <template #actions>
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
      </template>
    </w-dialog>

    <w-dialog 
     v-model="dialog0.show"
     :fullscreen="true"
     :width="dialogWidth"
     :max-width="dialogMaxWidth"
     :persistent="dialog0.persistent"
     :persistent-no-animation="dialog0.persistentNoAnimation"
     title-class="primary-dark1--bg white"
     content-class="dialog-content-custom">
     <template #title>
       Jumlah Pengguna
     </template>

     <div class="chart-grid" :class="{ 'chart-grid-mobile': isMobile }">
       <!-- Bar Chart untuk distribusi peranan -->
       <div class="chart-box-full">
         <div class="chart-row">
  
           <div class="chart-left">
             <GChart 
               type="ColumnChart" 
               :data="chartUserRole" 
               :options="getUserBarChartOptions()"
             />
           </div>

           <!-- <div class="chart-right">
             <div class="legend-container">
               <div 
                 v-for="(color, role) in roleColors" 
                 :key="role" 
                 class="legend-item"
               >
                 <span class="legend-color" :style="{ backgroundColor: color }"></span>
                 <span class="legend-text">{{ role }}</span>
               </div>
             </div>
           </div> -->

         </div>

       </div>

         
         <div v-for="(negeriMap, peranan) in cardPerananNegeri" :key="peranan" class="chart-box">
           <div class="chart-title">{{ peranan }}</div>
           <GChart 
             type="ColumnChart"
             :data="getCardChartData(peranan)"
             :options="getCardChartOptions(peranan)"
           />
         </div>


     </div>

     <template #actions>
       <w-button style="
                 background-color: #f0f0f0; 
                 border: 2px solid red; 
                 color: #333; 
                 padding: 7px 14px; 
                 font-size: 10px; 
                 font-weight: bold; 
                 border-radius: 4px; 
                 cursor: pointer;
             " @click="dialog0.show = false">TUTUP</w-button>
     </template>
   </w-dialog>

   <w-dialog 
  v-model="dialog1.show"
  :fullscreen="true"
  :width="dialogWidth"
  :max-width="dialogMaxWidth"
  :persistent="dialog1.persistent"
  :persistent-no-animation="dialog1.persistentNoAnimation"
  title-class="primary-dark1--bg white"
  content-class="dialog-content-custom">
  <template #title>
    Jumlah Premis
  </template>

  <div class="chart-grid" :class="{ 'chart-grid-mobile': isMobile }">
    <!-- Pie Chart untuk Kaedah Premis -->
    <div class="chart-box">
      <GChart 
        type="PieChart" 
        :data="chartKaedahPremis" 
        :options="getChartOptions('Kaedah Penternakan')"
      />
    </div>

    <!-- Pie Chart untuk Jenis Pengguna -->
    <div class="chart-box">
      <GChart 
        type="PieChart" 
        :data="chartJenisPengguna" 
        :options="getChartOptions('Jenis Pengguna')"
      />
    </div>

    <!-- Tabel Detail Premis -->
    <div class="chart-box-full">
      <div class="table-container">
        <table class="premis-table">
          <thead>
            <tr>
              <th>Kaedah Penternakan</th>
              <th>Jumlah Premis</th>
              <th>Jenis Pengguna</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in premisDetail" :key="index">
              <td>{{ item.kaedah_nama }}</td>
              <td class="text-center">{{ item.jumlah }}</td>
              <td>
                <div v-for="(jenis, jIndex) in item.jenis_pengguna" :key="jIndex" class="jenis-pengguna-item">
                  <span class="jenis-badge">{{ getJenisPenggunaName(jenis.jenis_pengguna_id) }}</span>
                  <span class="jumlah-badge">{{ jenis.jumlah }}</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <template #actions>
    <w-button style="
              background-color: #f0f0f0; 
              border: 2px solid red; 
              color: #333; 
              padding: 7px 14px; 
              font-size: 10px; 
              font-weight: bold; 
              border-radius: 4px; 
              cursor: pointer;
          " @click="dialog1.show = false">TUTUP</w-button>
  </template>
</w-dialog>

    <w-dialog 
      v-model="dialog2.show"
      :fullscreen="true"
      :width="dialogWidth"
      :max-width="dialogMaxWidth"
      :persistent="dialog2.persistent"
      :persistent-no-animation="dialog2.persistentNoAnimation"
      title-class="primary-dark1--bg white"
      content-class="dialog-content-custom">
      <template #title>
        Bil Pensijilan Baka
      </template>

      <div class="chart-grid" :class="{ 'chart-grid-mobile': isMobile }">
        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartTernakan" 
            :options="getChartOptions('Jenis Ternakan')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartJenisBaka" 
            :options="getChartOptions('Jenis Baka')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartJantina" 
            :options="getChartOptions('Jantina')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartBaka" 
            :options="getChartOptions('Baka')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartStatus" 
            :options="getChartOptions('Status')"
          />
        </div>
      </div>

      <template #actions>
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog2.show = false">TUTUP</w-button>
      </template>
    </w-dialog>

    <w-dialog 
     v-model="dialog3.show"
     :fullscreen="true"
     :width="dialogWidth"
     :max-width="dialogMaxWidth"
     :persistent="dialog3.persistent"
     :persistent-no-animation="dialog3.persistentNoAnimation"
     title-class="primary-dark1--bg white"
     content-class="dialog-content-custom">

     <template #title>
       Jumlah Servis AI
       <span v-if="selectedNegeri" class="selected-negeri">
         - Negeri: {{ selectedNegeri }}
       </span>
     </template>

     <div class="chart-grid" :class="{ 'chart-grid-mobile': isMobile }">
       <div class="chart-box">
         <GChart 
           type="PieChart" 
           :data="chartTernakan" 
           :options="getChartOptions('Jenis Ternakan')"
         />
       </div>

       <div class="chart-box">
         <GChart 
           type="PieChart" 
           :data="chartBaka" 
           :options="getChartOptions('Baka')"
         />
       </div>

       <div class="chart-box">
         <GChart 
           type="ColumnChart" 
           :data="safeChartData(chartNegeri, ['Negeri', 'Jumlah'])" 
           :options="getColumnChartOptions('Negeri', true)"
           @ready="onChartReady"
           @select="onNegeriChartSelect"
         />
       </div>

       <div class="chart-box">
         <div class="chart-header">
           <span>Daerah</span>
           <w-button 
             v-if="selectedNegeri" 
             @click="resetDaerahFilter" 
             class="reset-btn"
             x-small
             bg-color="grey-light3--bg"
           >
             Reset
           </w-button>
         </div>
         <GChart 
           type="ColumnChart" 
           :data="safeChartData(filteredChartDaerah, ['Daerah', 'Jumlah'])" 
           :options="getColumnChartOptions('Daerah')"
         />
       </div>
     </div>

     <template #actions>
       <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog3.show = false">TUTUP</w-button>
     </template>
   </w-dialog>

    <w-dialog 
      v-model="dialog4.show"
      :fullscreen="true"
      :width="dialogWidth"
      :max-width="dialogMaxWidth"
      :persistent="dialog4.persistent"
      :persistent-no-animation="dialog4.persistentNoAnimation"
      title-class="primary-dark1--bg white"
      content-class="dialog-content-custom">
      <template #title>
       Jumlah Servis PD
       <span v-if="selectedNegeri" class="selected-negeri">
         - Negeri: {{ selectedNegeri }}
       </span>
     </template>

      <div class="chart-grid" :class="{ 'chart-grid-mobile': isMobile }">
        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartTernakan" 
            :options="getChartOptions('Jenis Ternakan')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartBaka" 
            :options="getChartOptions('Baka')"
          />
        </div>

        <div class="chart-box">
         <GChart 
           type="ColumnChart" 
           :data="safeChartData(chartNegeri, ['Negeri', 'Jumlah'])" 
           :options="getColumnChartOptions('Negeri', true)"
           @ready="onChartReady"
           @select="onNegeriChartSelect"
         />
       </div>

       <div class="chart-box">
         <div class="chart-header">
           <span>Daerah</span>
           <w-button 
             v-if="selectedNegeri" 
             @click="resetDaerahFilter" 
             class="reset-btn"
             x-small
             bg-color="grey-light3--bg"
           >
             Reset
           </w-button>
         </div>
         <GChart 
           type="ColumnChart" 
           :data="safeChartData(filteredChartDaerah, ['Daerah', 'Jumlah'])" 
           :options="getColumnChartOptions('Daerah')"
         />
       </div>
     </div>
      <template #actions>
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog4.show = false">TUTUP</w-button>
      </template>
   </w-dialog>

    <w-dialog 
     v-model="dialog5.show"
      :fullscreen="true"
      :width="dialogWidth"
      :max-width="dialogMaxWidth"
      :persistent="dialog5.persistent"
      :persistent-no-animation="dialog5.persistentNoAnimation"
      title-class="primary-dark1--bg white"
      content-class="dialog-content-custom">
      <template #title>
       Jumlah Kelahiran Anak AI
       <span v-if="selectedNegeri" class="selected-negeri">
         - Negeri: {{ selectedNegeri }}
       </span>
     </template>

      <div class="chart-grid" :class="{ 'chart-grid-mobile': isMobile }">
        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartTernakan" 
            :options="getChartOptions('Jenis Ternakan')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartBaka" 
            :options="getChartOptions('Baka')"
          />
        </div>

        <div class="chart-box">
         <GChart 
           type="ColumnChart" 
           :data="safeChartData(chartNegeri, ['Negeri', 'Jumlah'])" 
           :options="getColumnChartOptions('Negeri', true)"
           @ready="onChartReady"
           @select="onNegeriChartSelect"
         />
       </div>

       <div class="chart-box">
         <div class="chart-header">
           <span>Daerah</span>
           <w-button 
             v-if="selectedNegeri" 
             @click="resetDaerahFilter" 
             class="reset-btn"
             x-small
             bg-color="grey-light3--bg"
           >
             Reset
           </w-button>
         </div>
         <GChart 
           type="ColumnChart" 
           :data="safeChartData(filteredChartDaerah, ['Daerah', 'Jumlah'])" 
           :options="getColumnChartOptions('Daerah')"
         />
       </div>
     </div>

      <template #actions>
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog5.show = false">TUTUP</w-button>
      </template>
    </w-dialog>

    <w-dialog 
     v-model="dialog6.show"
      :fullscreen="true"
      :width="dialogWidth"
      :max-width="dialogMaxWidth"
      :persistent="dialog6.persistent"
      :persistent-no-animation="dialog6.persistentNoAnimation"
      title-class="primary-dark1--bg white"
      content-class="dialog-content-custom">
      <template #title>
       Jumlah Kebuntingan AI
       <span v-if="selectedNegeri" class="selected-negeri">
         - Negeri: {{ selectedNegeri }}
       </span>
     </template>

      <div class="chart-grid" :class="{ 'chart-grid-mobile': isMobile }">
        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartTernakan" 
            :options="getChartOptions('Jenis Ternakan')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartBaka" 
            :options="getChartOptions('Baka')"
          />
        </div>

        <div class="chart-box">
         <GChart 
           type="ColumnChart" 
           :data="safeChartData(chartNegeri, ['Negeri', 'Jumlah'])" 
           :options="getColumnChartOptions('Negeri', true)"
           @ready="onChartReady"
           @select="onNegeriChartSelect"
         />
       </div>

       <div class="chart-box">
         <div class="chart-header">
           <span>Daerah</span>
           <w-button 
             v-if="selectedNegeri" 
             @click="resetDaerahFilter" 
             class="reset-btn"
             x-small
             bg-color="grey-light3--bg"
           >
             Reset
           </w-button>
         </div>
         <GChart 
           type="ColumnChart" 
           :data="safeChartData(filteredChartDaerah, ['Daerah', 'Jumlah'])" 
           :options="getColumnChartOptions('Daerah')"
         />
       </div>
     </div>

      <template #actions>
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog6.show = false">TUTUP</w-button>
      </template>
    </w-dialog>


    <w-dialog 
     v-model="dialog7.show"
      :fullscreen="true"
      :width="dialogWidth"
      :max-width="dialogMaxWidth"
      :persistent="dialog7.persistent"
      :persistent-no-animation="dialog7.persistentNoAnimation"
      title-class="primary-dark1--bg white"
      content-class="dialog-content-custom">
      <template #title>
       Jumlah Ternakan Ai
       <span v-if="selectedNegeri" class="selected-negeri">
         - Negeri: {{ selectedNegeri }}
       </span>
     </template>

      <div class="chart-grid" :class="{ 'chart-grid-mobile': isMobile }">
        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartTernakan" 
            :options="getChartOptions('Jenis Ternakan')"
          />
        </div>

        <div class="chart-box">
          <GChart 
            type="PieChart" 
            :data="chartBaka" 
            :options="getChartOptions('Baka')"
          />
        </div>

        <div class="chart-box">
         <GChart 
           type="ColumnChart" 
           :data="safeChartData(chartNegeri, ['Negeri', 'Jumlah'])" 
           :options="getColumnChartOptions('Negeri', true)"
           @ready="onChartReady"
           @select="onNegeriChartSelect"
         />
       </div>

       <div class="chart-box">
         <div class="chart-header">
           <span>Daerah</span>
           <w-button 
             v-if="selectedNegeri" 
             @click="resetDaerahFilter" 
             class="reset-btn"
             x-small
             bg-color="grey-light3--bg"
           >
             Reset
           </w-button>
         </div>
         <GChart 
           type="ColumnChart" 
           :data="safeChartData(filteredChartDaerah, ['Daerah', 'Jumlah'])" 
           :options="getColumnChartOptions('Daerah')"
         />
       </div>
     </div>

      <template #actions>
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog7.show = false">TUTUP</w-button>
      </template>
    </w-dialog>
  </div>
</template>

<script>
import { GChart } from "vue-google-charts";
export default {
  props: {
    d_tahun: { type: [Array, Object], required: true },
    role_id : String
  },
  components: {
        GChart
    },
  data() {
    return {
      cards2: [],
      premis: [],
      negeri: [],
      currentTime: "",
      currentDate: "",
      lkp_ternakan: [],
      selectedTernakanId: 0,
      lastItemData: null,
      isLoadingTernakan: false,
      selectedNegeri: null,
      chartJenisBaka: [['Jenis Baka', 'Jumlah']],
      chartKaedahPremis: [['Kaedah', 'Jumlah']],
       chartJenisPengguna: [['Jenis Pengguna', 'Jumlah']],
       premisDetail: [],
       jenisPenggunaMap: {
         1: 'Kerajaan',
         2: 'Swasta',
       },
      filteredChartDaerah: [['Daerah', 'Jumlah']],
      originalChartDaerah: [['Daerah', 'Jumlah']],
      chartServisAi: [["Tahun", "Jumlah"]],
      chartAnakAi: [["Tahun", "Jumlah"]],
      senarai_tahun: Array.from({ length: 5 }, (_, index) => {
        const year = new Date().getFullYear() - index;
        return { value: year, label: String(year) };
      }),
      // form: {
      // premis_id: null, 
      //  },
      dialog: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1800,
        item: {}
      },
      dialog1: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1800,
        item: {}
      },
      colorsList: [
        "#4285F4", // biru
        "#DB4437", // merah
        "#F4B400", // kuning
        "#0F9D58", // hijau
        "#AB47BC", // ungu
        "#00ACC1", // cyan
        "#FF7043", // orange
      ],
      dialog2: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1800,
        item: {}
      },
      dialog3: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1800,
        item: {}
      },
      dialog0: {
         valid: false,
         show: false,
         fullscreen: false,
         persistent: true,
         persistentNoAnimation: false,
         loading: false,
         width: 1800,
         item: {}
       },
       chartUserRole: [['Peranan', 'Jumlah', { role: 'style' }, { role: 'annotation' }]],
       chartUserNegeri: [],  
      cardPerananNegeri: {},
       userList: [],
       colorIndex: 0,
      dialog4: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1800,
        item: {}
      },
      dialog5: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1800,
        item: {}
      },
      dialog6: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1800,
        item: {}
      },
      dialog7: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1800,
        item: {}
      },
      bulan_tahun:[
        {value: 2, label: "TAHUN"},
        {value: 1, label: "BULAN BAGI TAHUN SEMASA"},
      ],
      carian_tahun :{bulan_tahun: 1},
      carian_bulan :{bulan_tahun: 1},
      d_servis: [],
      d_anak: [],
      chartTernakan: [
          ['Umur Hari','Berat Kg','ADG'],
        ],
      chartBaka: [
          ['Umur Hari','Berat Kg'],
        ],
      chartJurusan: [
          ['Umur Hari','ADG'],
        ],
      carian: { 
        premis_id: '',
        lkp_negeri_id: '',
        tahun: new Date().getFullYear() 
      },
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    isMobile() {
      return this.windowWidth < 768;
    },
    lkp_ternakanWithAll() {
    // Data dari API sudah format {value, label}
    if (this.lkp_ternakan.length > 0) {
      // Cek jika item pertama sudah "Semua"
      const firstItem = this.lkp_ternakan[0];
      const isFirstItemAll = firstItem.value === 0 && firstItem.label === 'Semua';
      
      if (!isFirstItemAll) {
        // Tambahkan "Semua" dengan format yang sama
        return [
          { value: 0, label: 'Semua' }, 
          ...this.lkp_ternakan
        ];
      }
    }
    return this.lkp_ternakan;
  },
    isTabletLandscape() {
      // Deteksi iPad mini landscape
      return this.windowWidth >= 768 && this.windowWidth <= 1024 && window.innerHeight < 500;
    },
    isDesktop() {
      return this.windowWidth >= 1025;
    },
    dialogWidth() {
      if (this.isMobile) return '100%';
      if (this.isTabletLandscape) return '90%';
      return '70%'; // Lebih kecil untuk desktop
    },
    dialogMaxWidth() {
      if (this.isMobile) return '100%';
      if (this.isTabletLandscape) return '1000px';
      return '800px'; // Lebih kecil untuk desktop
    }
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    getServis(){
      // this.carian_tahun.bulan_tahun = 1;
      this.$zcomm.get(this.api_service + 'dashboard/dashboard-servis?ind='+this.carian_tahun.bulan_tahun+'&role_id='+this.role_id, {}).then(res => {
            this.d_servis = res
         })
      
   },
   getAnak(){
// this.carian_tahun.bulan_tahun = 1;
      this.$zcomm.get(this.api_service + 'dashboard/dashboard-anak?ind='+this.carian_bulan.bulan_tahun+'&role_id='+this.role_id, {}).then(res => {
            this.d_anak = res
         })
      
   },
    tugas(row) {

       if (row.Tugas === 'Sahkan Pengguna') {
         window.location.href =
           window.route('administration.user.index') +
           '?status=4';
       }

       if (row.Tugas === 'Pelulus Baka Status Semakan') {
        window.location.href =
          window.route('baka.index') +
          '?lkp_status_id=30'; 
      }

    },


    

getColor() {
  const COLOR_PALETTE = [
    '#3b82f6', '#f97316', '#10b981', '#e11d48',
    '#8b5cf6', '#14b8a6', '#f43f5e', '#0ea5e9',
    '#a855f7', '#facc15', '#4ade80', '#fb923c'
  ];

  const color = COLOR_PALETTE[this.colorIndex % COLOR_PALETTE.length];
  this.colorIndex++;
  return color;
},

// Method untuk mendapatkan format legend yang lebih baik
getUserBarChartLegend() {
  if (!this.chartUserRole || this.chartUserRole.length <= 1 || !this.roleColors) {
    return { position: 'right', alignment: 'center' };
  }

  const legendItems = [];
  // Lewati header row
  for (let i = 1; i < this.chartUserRole.length; i++) {
    const roleData = this.chartUserRole[i];
    const roleName = roleData[0];
    const count = roleData[1];
    const color = this.roleColors[roleName] || this.getRandomColor();
    
    legendItems.push({
      text: `${roleName} (${count})`,
      color: color
    });
  }

  return {
    position: 'right',
    alignment: 'center',
    textStyle: {
      fontSize: this.isMobile ? 10 : 12
    },
    // Jika ingin custom legend, bisa gunakan ini
    // pagingTextStyle: { color: 'blue' }
  };
},

getRoleCount(roleName) {
  // Gunakan roleColors yang sudah memiliki mapping
  // Cari di chartUserRole
  const roleData = this.chartUserRole?.find(row => row[0] === roleName);
  return roleData ? roleData[1] : 0;
},

getRoleSeriesColors() {
  const series = {};
  
  // Pastikan chartUserRole dan roleColors sudah ada
  if (!this.chartUserRole || this.chartUserRole.length <= 1 || !this.roleColors) {
    return series;
  }
  
  // Lewati header row (index 0)
  for (let i = 1; i < this.chartUserRole.length; i++) {
    const roleData = this.chartUserRole[i];
    const roleName = roleData[0];
    
    if (this.roleColors[roleName]) {
      // Gunakan index 0-based untuk series
      series[i-1] = {
        color: this.roleColors[roleName],
        visibleInLegend: true
      };
    }
  }
  
  return series;
},

// Method untuk mendapatkan warna berdasarkan nama peranan
getColorForRole(roleName) {
  return this.roleColors?.[roleName] || this.getRandomColor();
},

// Method untuk warna acak (fallback)
getRandomColor() {
  const colors = [
    '#3b82f6', '#f97316', '#10b981', '#ef4444', '#8b5cf6',
    '#06b6d4', '#84cc16', '#f59e0b', '#ec4899', '#6366f1'
  ];
  return colors[Math.floor(Math.random() * colors.length)];
},

getCardChartOptions(peranan) {
  const roleColor = this.roleColors?.[peranan] || '#3b82f6';
  
  return {
    title: `Jumlah ${peranan}`,
    titleTextStyle: {
      fontSize: this.isMobile ? 12 : 14,
      bold: true
    },
    legend: { position: 'none' },

    height: 250,
    bar: { groupWidth: '45%' },       // bar lebih renggang

    colors: [roleColor],

    vAxis: {
      minValue: 0,
      format: '0',
      textStyle: {
        fontSize: this.isMobile ? 9 : 10
      }
    },

    hAxis: {
      slantedText: false,             // <-- kunci utama !
      textStyle: { 
        fontSize: this.isMobile ? 9 : 10 
      }
    },

    chartArea: {
      width: '88%',
      height: '70%',
      top: 40,
      left: 40,
      right: 10
    },

    tooltip: { isHtml: true }
  };
},



   getTarikhaiman(){
      // this.carian_tahun.bulan_tahun = 1;
      this.$zcomm.get(this.api_service + 'dashboard/dashboard-tugasanadmin', {}).then(res => {
            this.tarikh_aiman = res
         })
      
       },


    getCardChartData(peranan) {
        const negeriMap = this.cardPerananNegeri[peranan] || {};

        const data = [['Negeri', 'Jumlah']];

        Object.entries(negeriMap).forEach(([negeri, jumlah]) => {
          data.push([negeri, jumlah]);
        });

        return data;
      },
    getTugasan(){
      // this.carian_tahun.bulan_tahun = 1;
      this.$zcomm.get(this.api_service + 'dashboard/dashboard-tugasanaiman', {}).then(res => {
            this.tugasan = res
         })
      },

   

    // item(index){
    //   if(index==0){
    //      var hantar = 2;
    //      window.location.href = window.route('administration.user')+'?hantar='+hantar;
    //   }else{
    //      window.location.href = window.route('se.pengeluaran.index')+'?lkp_status_id='+index;
    //   } 
    // },

  async getPremis(id) {
      try {
        const res = await this.$zcomm.get(this.api_service + "lookup/premis/"+id, {});
        this.premis = res.data ?? res;
      } catch (e) {
        console.error("Gagal ambil premis:", e);
      }
    },

    async getNegeri() {
      try {
        const res = await this.$zcomm.get(this.api_service + "lookup/negeri_user", {});
        this.negeri = res.data ?? res;
      } catch (e) {
        console.error("Gagal ambil premis:", e);
      }
    },

  async getData(item) {
  if (item === 1) {
    this.carian.tahun = new Date().getFullYear();
  }

  try {
    const res = await this.$zcomm.get(
      this.api_service +
        "dashboard/dashboard-admin?tahun=" + this.carian.tahun +
        "&premis_id=" + (this.carian.premis_id ?? ""),
      {}
    );

    const data = res.data ?? res;

    if (Array.isArray(data)) {
      this.cards2 = data;
      this.lkp_ternakan =
        data.find(d => d.keterangan === "Jumlah Ternakan")?.lkp_ternakan ?? [];

      // --- Inisialisasi chart ---
      this.chartServisAi = [["Bulan", "Jumlah"]];
      this.chartAnakAi = [["Bulan", "Jumlah"]];

      // --- Servis AI ---
      const servisAi = data.find(d => d.keterangan === "Jumlah Servis AI");
      const groupedServis = {};
      if (servisAi && Array.isArray(servisAi.data)) {
        servisAi.data.forEach(row => {
          const bulan = parseInt(row.bulan, 10);
          if (!bulan) return;
          groupedServis[bulan] = (groupedServis[bulan] || 0) + 1;
        });
      }
      for (let i = 1; i <= 12; i++) {
        this.chartServisAi.push([this.formatBulan(i), groupedServis[i] || 0]);
      }

      // --- Anak AI ---
      const anakAi = data.find(d => d.keterangan === "Jumlah Kelahiran Anak AI");
      const groupedAnak = {};
      if (anakAi && Array.isArray(anakAi.data)) {
        anakAi.data.forEach(row => {
          const bulan = parseInt(row.bulan, 10);
          if (!bulan) return;
          groupedAnak[bulan] = (groupedAnak[bulan] || 0) + 1;
        });
      }
      for (let i = 1; i <= 12; i++) {
        this.chartAnakAi.push([this.formatBulan(i), groupedAnak[i] || 0]);
      }

    } else {
      this.cards2 = [];
      this.chartServisAi = [["Bulan", "Jumlah"]];
      this.chartAnakAi = [["Bulan", "Jumlah"]];
    }
  } catch (err) {
    console.error("Gagal ambil data dashboard:", err);
    this.cards2 = [];
    this.chartServisAi = [["Bulan", "Jumlah"]];
    this.chartAnakAi = [["Bulan", "Jumlah"]];
  }
},

safeChartData(data, headers) {
    // Cegah error: jika tidak ada data valid, tampilkan "Tiada Data"
    if (!data || data.length <= 1) {
      return [headers, ['Tiada Data', 0]]
    }

    // Pastikan semua value kedua bertipe angka
    const cleanData = data.map((row, i) => {
      if (i === 0) return row // header
      return [row[0], Number(row[1]) || 0]
    })
    return cleanData
  },

formatBulan(val) {
  const bulan = [
    "Jan", "Feb", "Mar", "Apr", "Mei", "Jun",
    "Jul", "Agu", "Sep", "Okt", "Nov", "Des"
  ];

  if (!val) return val;

  // numeric (misal "09" atau 9)
  if (!isNaN(val)) {
    const idx = parseInt(val, 10) - 1;
    return bulan[idx] || val;
  }

  // string nama bulan full
  const lower = val.toLowerCase();
  const map = {
    januari: "Jan", februari: "Feb", maret: "Mar", april: "Apr",
    mei: "Mei", juni: "Jun", juli: "Jul", agustus: "Agu",
    september: "Sep", oktober: "Okt", november: "Nov", desember: "Des"
  };
  return map[lower] || val;
},

updateDateTime() {
  const now = new Date();

  
  this.currentDate = now.toLocaleDateString("ms-MY", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
  });

  
  this.currentTime = now.toLocaleTimeString("en-US", { 
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true 
  });
},

async getLkpTernakan() {
    try {
      const res = await this.$zcomm.get(this.api_service + "lookup/ternakan", {});
      const data = res.data ?? res;
      this.lkp_ternakan = Array.isArray(data) ? data : [];
      console.log('Data lkp_ternakan dari API:', this.lkp_ternakan);
    } catch (error) {
      console.error("Gagal mengambil data ternakan:", error);
      this.lkp_ternakan = [];
    }
  },

  
  openDialog(index) {
  const card = this.cards2[index]; 
  this.lastItemData = card; 

  // Pastikan lkp_ternakan terisi dengan benar
  if (card && card.lkp_ternakan && Array.isArray(card.lkp_ernakan)) {
    this.lkp_ternakan = [...card.lkp_ternakan];
  } else {
    this.getLkpTernakan();
  }
  
  // Set default selection
  this.selectedTernakanId = 0; 

  this.$nextTick(() => {
    if (index === 1) {
      this.ChartPremis(card);       
      this.dialog1.show = true;
    } else if (index === 0) {
      this.ChartUsers(card);     
      this.dialog0.show = true;    
    } else if (index === 2) {
      this.Chart(card);         
      this.dialog.show = true;     
    } else if (index === 3) {
      this.ChartTulen(card); 
      this.dialog2.show = true;    
    } else if (index === 4) {
      this.ChartAi(card); 
      this.dialog3.show = true;    
    } else if (index === 5) {
      this.ChartPd(card);
      this.dialog4.show = true;    
    } else if (index === 6) {
      this.ChartTernakan(card);
      this.dialog7.show = true;    
    } else if (index === 7) {
      this.ChartAnak(card); 
      this.dialog5.show = true;    
    } else if (index === 8) {
      this.ChartBunting(card);
      this.dialog6.show = true;    
    } else if (index === 9) {
    }
  });
},

   Chart(item) {
  const list = item?.data ?? [];
  let filtered = list;
  
  if (this.selectedTernakanId && this.selectedTernakanId !== 0) {
    filtered = list.filter(row => {
      // Cek dengan format yang sesuai
      const ternakanValue = row.lkp_ternakan?.value || row.lkp_ternakan?.id;
      return ternakanValue === this.selectedTernakanId;
    });
  }

  // reset chart
  this.chartBaka = [['Baka', 'Jumlah']];
  this.chartJurusan = [['Jurusan', 'Jumlah']];
  this.chartJantina = [['Jantina', 'Jumlah']];
  this.chartTernakan = [['Jenis', 'Jumlah']];
  
  // Update struktur chartUmur DENGAN ANNOTATION COLUMNS
  this.chartUmur = [
    ['Umur', 'Jantan', { role: 'annotation', type: 'string' }, 'Betina', { role: 'annotation', type: 'string' }]
  ];

  const bakaMap = {};
  const jurusanMap = {};
  const jantinaMap = {};
  const ternakanMap = {};
  
  const umurMap = {
     '≤ 6 Bulan': { jantan: 0, betina: 0 },
     '1 Tahun': { jantan: 0, betina: 0 },
     '1 Tahun 6 Bulan': { jantan: 0, betina: 0 },
     '2 Tahun': { jantan: 0, betina: 0 },
     '3 Tahun': { jantan: 0, betina: 0 },
     '4 Tahun': { jantan: 0, betina: 0 },
     '≥ 5 Tahun': { jantan: 0, betina: 0 }
   };


  filtered.forEach(row => {
    const bakaNama = row.lkp_baka?.nama ?? 'Tidak Diketahui';
    bakaMap[bakaNama] = (bakaMap[bakaNama] || 0) + 1;

    const jurusanNama = row.lkp_jurusan?.nama ?? 'Tidak Diketahui';
    jurusanMap[jurusanNama] = (jurusanMap[jurusanNama] || 0) + 1;

    const jantinaNama = row.jantina == 1 ? 'Jantan' : row.jantina == 2 ? 'Betina' : 'Tidak Diketahui';
    jantinaMap[jantinaNama] = (jantinaMap[jantinaNama] || 0) + 1;

    const ternakanNama = row.lkp_ternakan?.nama ?? 'Tidak Diketahui';
    ternakanMap[ternakanNama] = (ternakanMap[ternakanNama] || 0) + 1;

    if (row.tarikh_lahir) {
      const lahir = new Date(row.tarikh_lahir);
      if (!isNaN(lahir)) {
        const now = new Date();
        const umurBulan =
          (now.getFullYear() - lahir.getFullYear()) * 12 +
          (now.getMonth() - lahir.getMonth());

        let range;
         if (umurBulan <= 6) range = '≤ 6 Bulan';
         else if (umurBulan <= 12) range = '1 Tahun';
         else if (umurBulan <= 18) range = '1 Tahun 6 Bulan';
         else if (umurBulan <= 24) range = '2 Tahun';
         else if (umurBulan <= 36) range = '3 Tahun';
         else if (umurBulan <= 48) range = '4 Tahun';
         else range = '≥ 5 Tahun';

        if (row.jantina == 1) {
          umurMap[range].jantan++;
        } else if (row.jantina == 2) {
          umurMap[range].betina++;
        }
      }
    }
  });

  Object.entries(bakaMap).forEach(([nama, jumlah]) => this.chartBaka.push([`${nama} (${jumlah})`, jumlah]));
  Object.entries(jurusanMap).forEach(([nama, jumlah]) => this.chartJurusan.push([`${nama} (${jumlah})`, jumlah]));
  Object.entries(jantinaMap).forEach(([nama, jumlah]) => this.chartJantina.push([`${nama} (${jumlah})`, jumlah]));
  Object.entries(ternakanMap).forEach(([nama, jumlah]) => this.chartTernakan.push([`${nama} (${jumlah})`, jumlah]));
  
  // Format data umur DENGAN ANNOTATIONS
  Object.entries(umurMap).forEach(([range, data]) => {
    this.chartUmur.push([
      range, 
      data.jantan, 
      data.jantan > 0 ? data.jantan.toString() : '', // Annotation untuk Jantan
      data.betina, 
      data.betina > 0 ? data.betina.toString() : ''  // Annotation untuk Betina
    ]);
  });
},

ChartPremis(item) {
  const detail = item?.detail ?? [];
  this.premisDetail = detail;

 
  this.chartKaedahPremis = [['Kaedah', 'Jumlah']];
  this.chartJenisPengguna = [['Jenis Pengguna', 'Jumlah']];

  
  const kaedahMap = {};
  const jenisPenggunaMap = {};

  detail.forEach(item => {
    const kaedahNama = item.kaedah_nama || 'Tidak Diketahui';
    kaedahMap[kaedahNama] = (kaedahMap[kaedahNama] || 0) + item.jumlah;

    // Process data jenis pengguna
    if (item.jenis_pengguna && Array.isArray(item.jenis_pengguna)) {
      item.jenis_pengguna.forEach(jenis => {
        const jenisNama = this.getJenisPenggunaName(jenis.jenis_pengguna_id);
        jenisPenggunaMap[jenisNama] = (jenisPenggunaMap[jenisNama] || 0) + jenis.jumlah;
      });
    }
  });

  // Build chart data untuk kaedah
  Object.entries(kaedahMap).forEach(([kaedahNama, jumlah]) => {
  this.chartKaedahPremis.push([`${kaedahNama} (${jumlah})`, jumlah]);
});


  // Build chart data untuk jenis pengguna
  Object.entries(jenisPenggunaMap).forEach(([jenisNama, jumlah]) => {
  this.chartJenisPengguna.push([`${jenisNama} (${jumlah})`, jumlah]);
});


  // Jika tidak ada data, tampilkan placeholder
  if (this.chartKaedahPremis.length === 1) {
    this.chartKaedahPremis.push(['Tiada Data', 1]);
  }
  if (this.chartJenisPengguna.length === 1) {
    this.chartJenisPengguna.push(['Tiada Data', 1]);
  }

  console.log('Premis Detail:', this.premisDetail);
  console.log('Chart Kaedah:', this.chartKaedahPremis);
  console.log('Chart Jenis Pengguna:', this.chartJenisPengguna);
},

// Method untuk mendapatkan nama jenis pengguna
getJenisPenggunaName(jenisId) {
  return this.jenisPenggunaMap[jenisId] || `Jenis ${jenisId}`;
},
ChartUsers(item) {
  const list = item?.data ?? [];

  this.chartUserRole = [
    ['Peranan', 'Jumlah', { role: 'style' }, { role: 'annotation' }]
  ];

  this.chartUserNegeri = [['Negeri', 'Jumlah']];
  this.userList = [];

  this.roleColors = {}; 

  const roleMap = {};
  const perananNegeriMap = {};
  const negeriMap = {};

  // === Fungsi untuk memecah label jadi multi-line ===
  const tidyLabel = (label) => {
    const words = label.split(' ');

    if (words.length >= 3) {
      // 3 kata atau lebih → 2 baris
      return words.slice(0, 2).join(' ') + '\n' + words.slice(2).join(' ');
    } else if (words.length === 2) {
      // 2 kata → 2 baris
      return words[0] + '\n' + words[1];
    }

    return label; // 1 kata → tetap
  };

  list.forEach(userItem => {
    const user = userItem.user;
    if (!user) return;

    const roles = user.role.split(',').map(r => r.trim());
    const negeri = user.lkp_negeri.nama || 'Tidak Diketahui';

    roles.forEach(role => {
      roleMap[role] = (roleMap[role] || 0) + 1;

      if (!perananNegeriMap[role]) perananNegeriMap[role] = {};
      perananNegeriMap[role][negeri] =
        (perananNegeriMap[role][negeri] || 0) + 1;
    });

    negeriMap[negeri] = (negeriMap[negeri] || 0) + 1;

    this.userList.push({
      nama: user.nama,
      role: user.role,
      negeri
    });
  });

  Object.entries(roleMap).forEach(([role, count]) => {
    const color = this.getColor();
    this.roleColors[role] = color;

    // === Terapkan tidyLabel() di sini ===
    this.chartUserRole.push([
      tidyLabel(role),  // ⬅ label sudah multiline
      count,
      `color: ${color}`,
      count
    ]);
  });

  Object.entries(negeriMap).forEach(([negeri, count]) => {
    this.chartUserNegeri.push([negeri, count]);
  });

  this.cardPerananNegeri = perananNegeriMap;
},
   
      ChartTulen(item) {
    const list = item.data ?? [];

    this.chartBaka = [['Baka', 'Jumlah']];
    this.chartJantina = [['Jantina', 'Jumlah']];
    this.chartTernakan = [['Jenis', 'Jumlah']];
    this.chartStatus = [['Status', 'Jumlah']];
    this.chartJenisBaka = [['Jenis Baka', 'Jumlah']]; // <-- TAMBAH INI

    const bakaMap = {};
    const jantinaMap = {};
    const ternakanMap = {};
    const statusMap = {};
    const jenisBakaMap = {}; // <-- TAMBAH INI

    list.forEach(row => {
      const bakaNama = row.lkp_baka?.nama ?? 'Tidak Diketahui';
      bakaMap[bakaNama] = (bakaMap[bakaNama] || 0) + 1;

      const jantinaNama = row.jantina == 1 ? 'Jantan' : row.jantina == 2 ? 'Betina' : 'Tidak Diketahui';
      jantinaMap[jantinaNama] = (jantinaMap[jantinaNama] || 0) + 1;

      const ternakanNama = row.lkp_ternakan?.nama ?? 'Tidak Diketahui';
      ternakanMap[ternakanNama] = (ternakanMap[ternakanNama] || 0) + 1;

      const statusNama = row.lkp_status?.nama ?? 'Tidak Diketahui';
      statusMap[statusNama] = (statusMap[statusNama] || 0) + 1;

      // KIRA JENIS BAKA
      let jenisNama = 'Tidak Diketahui';
      if (row.lkp_jenis_baka?.nama) {
          jenisNama = row.lkp_jenis_baka.nama;
      } else if (row.lkp_jenis_baka_id == 1) {
          jenisNama = 'Hybrid';
      } else if (row.lkp_jenis_baka_id == 2) {
          jenisNama = 'Tulen';
      }
      jenisBakaMap[jenisNama] = (jenisBakaMap[jenisNama] || 0) + 1;
    });

    Object.entries(bakaMap).forEach(([nama, jumlah]) => this.chartBaka.push([`${nama} (${jumlah})`, jumlah]));
    Object.entries(jantinaMap).forEach(([nama, jumlah]) => this.chartJantina.push([`${nama} (${jumlah})`, jumlah]));
    Object.entries(ternakanMap).forEach(([nama, jumlah]) => this.chartTernakan.push([`${nama} (${jumlah})`, jumlah]));
    Object.entries(statusMap).forEach(([nama, jumlah]) => this.chartStatus.push([`${nama} (${jumlah})`, jumlah]));
    Object.entries(jenisBakaMap).forEach(([nama, jumlah]) => this.chartJenisBaka.push([`${nama} (${jumlah})`, jumlah])); // <-- TAMBAH INI
  },

  ChartPd(item) {

  const list = item.data ?? []

  console.log('Data for ChartPd:', list)

  this.chartBaka = [['Baka', 'Jumlah']]
  this.chartNegeri = [['Negeri', 'Jumlah']]
  this.chartTernakan = [['Jenis', 'Jumlah']]
  this.chartDaerah = [['Daerah', 'Jumlah']]
  this.filteredChartDaerah = [['Daerah', 'Jumlah']]

  const bakaMap = {}
  const ternakanMap = {}
  const negeriMap = {}
  const daerahMap = {}

  const servisSeen = new Set() 

  this.originalDaerahData = []

  list.forEach(row => {

    const bakaNama = row.lkp_baka?.nama ?? 'Tidak Diketahui'
    const ternakanNama = row.lkp_ternakan?.nama ?? 'Tidak Diketahui'
    const negeriNama = row.lkp_negeri?.nama ?? 'Tidak Diketahui'
    const daerahNama = row.lkp_daerah?.nama ?? 'Tidak Diketahui'
    const negeriId = row.lkp_negeri?.id ?? null
    const artId = row.art_id ?? null

    
    bakaMap[bakaNama] = (bakaMap[bakaNama] || 0) + 1

    ternakanMap[ternakanNama] = (ternakanMap[ternakanNama] || 0) + 1

    if (!servisSeen.has(artId)) {

      servisSeen.add(artId)

      negeriMap[negeriNama] = (negeriMap[negeriNama] || 0) + 1
      daerahMap[daerahNama] = (daerahMap[daerahNama] || 0) + 1

      this.originalDaerahData.push({
        daerah: daerahNama,
        negeri: negeriNama,
        negeriId: negeriId,
        count: 1
      })

    }

  })



  Object.entries(negeriMap).forEach(([nama, jumlah]) => {
    this.chartNegeri.push([nama, jumlah])
  })

  Object.entries(bakaMap).forEach(([nama, jumlah]) => {
    this.chartBaka.push([`${nama} (${jumlah})`, jumlah])
  })

  Object.entries(ternakanMap).forEach(([nama, jumlah]) => {
    this.chartTernakan.push([`${nama} (${jumlah})`, jumlah])
  })

  Object.entries(daerahMap).forEach(([nama, jumlah]) => {

    this.chartDaerah.push([nama, jumlah])
    this.filteredChartDaerah.push([nama, jumlah])

  })


  this.originalChartDaerah = [...this.chartDaerah]
  this.selectedNegeri = null

  console.log('Chart Negeri data:', this.chartNegeri)
  console.log('Chart Daerah data:', this.chartDaerah)

},

  ChartTernakan(item) {
     const list = item.data ?? [];
     console.log('Data for ChartPd:', list); // Debug

     this.chartBaka = [['Baka', 'Jumlah']];
     this.chartNegeri = [['Negeri', 'Jumlah']];
     this.chartTernakan = [['Jenis', 'Jumlah']];
     this.chartDaerah = [['Daerah', 'Jumlah']];
     this.filteredChartDaerah = [['Daerah', 'Jumlah']];

     const bakaMap = {};
     const negeriMap = {};
     const ternakanMap = {};
     const daerahMap = {};
     
     // Simpan data asli untuk filtering
     this.originalDaerahData = [];

     list.forEach(row => {
       const bakaNama = row.lkp_baka?.nama ?? 'Tidak Diketahui';
       bakaMap[bakaNama] = (bakaMap[bakaNama] || 0) + 1;

       const negeriNama = row.lkp_negeri?.nama ?? 'Tidak Diketahui';
       negeriMap[negeriNama] = (negeriMap[negeriNama] || 0) + 1;

       const ternakanNama = row.lkp_ternakan?.nama ?? 'Tidak Diketahui';
       ternakanMap[ternakanNama] = (ternakanMap[ternakanNama] || 0) + 1;

       const daerahNama = row.lkp_daerah?.nama ?? 'Tidak Diketahui';
       const negeriId = row.lkp_negeri?.id;
       
       daerahMap[daerahNama] = (daerahMap[daerahNama] || 0) + 1;
       
       // Simpan data asli untuk filtering
       this.originalDaerahData.push({
         daerah: daerahNama,
         negeri: negeriNama,
         negeriId: negeriId,
         count: 1
       });
     });

     // Pastikan data chart negeri valid
     Object.entries(negeriMap).forEach(([nama, jumlah]) => {
       if (nama && jumlah > 0) {
         this.chartNegeri.push([nama, jumlah]);
       }
     });

     Object.entries(bakaMap).forEach(([nama, jumlah]) => this.chartBaka.push([`${nama} (${jumlah})`, jumlah]));
     Object.entries(ternakanMap).forEach(([nama, jumlah]) => this.chartTernakan.push([`${nama} (${jumlah})`, jumlah]));
     Object.entries(daerahMap).forEach(([nama, jumlah]) => {
       this.chartDaerah.push([nama, jumlah]);
       this.filteredChartDaerah.push([nama, jumlah]);
     });
     
     // Simpan data asli chartDaerah
     this.originalChartDaerah = [...this.chartDaerah];
     this.selectedNegeri = null;
     
     console.log('Chart Negeri data:', this.chartNegeri); // Debug
     console.log('Chart Daerah data:', this.chartDaerah); // Debug
   },

   formatNumber(value) {
    if (value === null || value === undefined) return '0';
    const num = parseInt(value);
    return num.toLocaleString('en-MY'); 
  },
  ChartAnak(item) {
     const list = item.data ?? [];
     console.log('Data for ChartPd:', list); // Debug

     this.chartBaka = [['Baka', 'Jumlah']];
     this.chartNegeri = [['Negeri', 'Jumlah']];
     this.chartTernakan = [['Jenis', 'Jumlah']];
     this.chartDaerah = [['Daerah', 'Jumlah']];
     this.filteredChartDaerah = [['Daerah', 'Jumlah']];

     const bakaMap = {};
     const negeriMap = {};
     const ternakanMap = {};
     const daerahMap = {};
     
     // Simpan data asli untuk filtering
     this.originalDaerahData = [];

     list.forEach(row => {
       const bakaNama = row.lkp_baka?.nama ?? 'Tidak Diketahui';
       bakaMap[bakaNama] = (bakaMap[bakaNama] || 0) + 1;

       const negeriNama = row.lkp_negeri?.nama ?? 'Tidak Diketahui';
       negeriMap[negeriNama] = (negeriMap[negeriNama] || 0) + 1;

       const ternakanNama = row.lkp_ternakan?.nama ?? 'Tidak Diketahui';
       ternakanMap[ternakanNama] = (ternakanMap[ternakanNama] || 0) + 1;

       const daerahNama = row.lkp_daerah?.nama ?? 'Tidak Diketahui';
       const negeriId = row.lkp_negeri?.id;
       
       daerahMap[daerahNama] = (daerahMap[daerahNama] || 0) + 1;
       
       // Simpan data asli untuk filtering
       this.originalDaerahData.push({
         daerah: daerahNama,
         negeri: negeriNama,
         negeriId: negeriId,
         count: 1
       });
     });

     // Pastikan data chart negeri valid
     Object.entries(negeriMap).forEach(([nama, jumlah]) => {
       if (nama && jumlah > 0) {
         this.chartNegeri.push([nama, jumlah]);
       }
     });

     Object.entries(bakaMap).forEach(([nama, jumlah]) => this.chartBaka.push([`${nama} (${jumlah})`, jumlah]));
     Object.entries(ternakanMap).forEach(([nama, jumlah]) => this.chartTernakan.push([`${nama} (${jumlah})`, jumlah]));
     Object.entries(daerahMap).forEach(([nama, jumlah]) => {
       this.chartDaerah.push([nama, jumlah]);
       this.filteredChartDaerah.push([nama, jumlah]);
     });
     
     // Simpan data asli chartDaerah
     this.originalChartDaerah = [...this.chartDaerah];
     this.selectedNegeri = null;
     
     console.log('Chart Negeri data:', this.chartNegeri); // Debug
     console.log('Chart Daerah data:', this.chartDaerah); // Debug
   },

  ChartBunting(item) {
     const list = item.data ?? [];
     console.log('Data for ChartPd:', list); // Debug

     this.chartBaka = [['Baka', 'Jumlah']];
     this.chartNegeri = [['Negeri', 'Jumlah']];
     this.chartTernakan = [['Jenis', 'Jumlah']];
     this.chartDaerah = [['Daerah', 'Jumlah']];
     this.filteredChartDaerah = [['Daerah', 'Jumlah']];

     const bakaMap = {};
     const negeriMap = {};
     const ternakanMap = {};
     const daerahMap = {};
     
     // Simpan data asli untuk filtering
     this.originalDaerahData = [];

     list.forEach(row => {
       const bakaNama = row.lkp_baka?.nama ?? 'Tidak Diketahui';
       bakaMap[bakaNama] = (bakaMap[bakaNama] || 0) + 1;

       const negeriNama = row.lkp_negeri?.nama ?? 'Tidak Diketahui';
       negeriMap[negeriNama] = (negeriMap[negeriNama] || 0) + 1;

       const ternakanNama = row.lkp_ternakan?.nama ?? 'Tidak Diketahui';
       ternakanMap[ternakanNama] = (ternakanMap[ternakanNama] || 0) + 1;

       const daerahNama = row.lkp_daerah?.nama ?? 'Tidak Diketahui';
       const negeriId = row.lkp_negeri?.id;
       
       daerahMap[daerahNama] = (daerahMap[daerahNama] || 0) + 1;
       
       // Simpan data asli untuk filtering
       this.originalDaerahData.push({
         daerah: daerahNama,
         negeri: negeriNama,
         negeriId: negeriId,
         count: 1
       });
     });

     // Pastikan data chart negeri valid
     Object.entries(negeriMap).forEach(([nama, jumlah]) => {
       if (nama && jumlah > 0) {
         this.chartNegeri.push([nama, jumlah]);
       }
     });

     Object.entries(bakaMap).forEach(([nama, jumlah]) => this.chartBaka.push([`${nama} (${jumlah})`, jumlah]));
     Object.entries(ternakanMap).forEach(([nama, jumlah]) => this.chartTernakan.push([`${nama} (${jumlah})`, jumlah]));
     Object.entries(daerahMap).forEach(([nama, jumlah]) => {
       this.chartDaerah.push([nama, jumlah]);
       this.filteredChartDaerah.push([nama, jumlah]);
     });
     
     // Simpan data asli chartDaerah
     this.originalChartDaerah = [...this.chartDaerah];
     this.selectedNegeri = null;
     
     console.log('Chart Negeri data:', this.chartNegeri); // Debug
     console.log('Chart Daerah data:', this.chartDaerah); // Debug
   },

  ChartAi(item) {
  const list = item.data ?? [];

  this.chartBaka = [['Baka', 'Jumlah']];
  this.chartNegeri = [['Negeri', 'Jumlah']];
  this.chartTernakan = [['Jenis', 'Jumlah']];
  this.chartDaerah = [['Daerah', 'Jumlah']];
  this.filteredChartDaerah = [['Daerah', 'Jumlah']];

  const bakaMap = {};
  const ternakanMap = {};
  const negeriMap = {};
  const daerahMap = {};

  // penting untuk elak duplicate ART
  const artTracker = new Set();

  this.originalDaerahData = [];

  list.forEach(row => {

    
    const bakaNama = row.lkp_baka?.nama ?? 'Tidak Diketahui';
    bakaMap[bakaNama] = (bakaMap[bakaNama] || 0) + 1;

    
    const ternakanNama = row.lkp_ternakan?.nama ?? 'Tidak Diketahui';
    ternakanMap[ternakanNama] = (ternakanMap[ternakanNama] || 0) + 1;


    if (!artTracker.has(row.art_id)) {

      artTracker.add(row.art_id);

      const negeriNama = row.lkp_negeri?.nama ?? 'Tidak Diketahui';
      const daerahNama = row.lkp_daerah?.nama ?? 'Tidak Diketahui';
      const negeriId   = row.lkp_negeri?.id ?? null;

      negeriMap[negeriNama] = (negeriMap[negeriNama] || 0) + 1;
      daerahMap[daerahNama] = (daerahMap[daerahNama] || 0) + 1;

      this.originalDaerahData.push({
        daerah: daerahNama,
        negeri: negeriNama,
        negeriId: negeriId,
        count: 1
      });
    }

  });

  
  Object.entries(negeriMap).forEach(([nama, jumlah]) => {
    this.chartNegeri.push([nama, jumlah]);
  });

  
  Object.entries(bakaMap).forEach(([nama, jumlah]) => {
    this.chartBaka.push([`${nama} (${jumlah})`, jumlah]);
  });

  
  Object.entries(ternakanMap).forEach(([nama, jumlah]) => {
    this.chartTernakan.push([`${nama} (${jumlah})`, jumlah]);
  });

 
  Object.entries(daerahMap).forEach(([nama, jumlah]) => {
    this.chartDaerah.push([nama, jumlah]);
    this.filteredChartDaerah.push([nama, jumlah]);
  });

  this.originalChartDaerah = [...this.chartDaerah];
  this.selectedNegeri = null;
},


   getUserBarChartOptions() {
     return {
       title: 'Peranan Pengguna',
       titleTextStyle: {
         fontSize: this.isMobile ? 14 : 16,
         bold: true
       },

       legend: { 
         position: 'none' // Legend dipindah ke samping
       },

       series: this.getRoleSeriesColors(),

       annotations: {
         alwaysOutside: true,
         textStyle: {
           fontSize: this.isMobile ? 10 : 12,
           bold: true
         }
       },

       hAxis: { 
           title: 'Peranan',
           slantedText: false,
           textStyle: { fontSize: this.isMobile ? 10 : 11 }
         },


       vAxis: { 
         title: 'Jumlah Pengguna',
         minValue: 0,
         format: '0',
         textStyle: { fontSize: this.isMobile ? 10 : 11 }
       },

       // PERBAIKAN UTAMA: chartArea diperlebar ke kanan
       chartArea: { 
         width: this.isMobile ? '75%' : '80%', // Diperlebar
         height: this.isMobile ? '65%' : '75%',
         top: 40,
         left: this.isMobile ? 25 : 60,
         right: this.isMobile ? 20 : 30, // Diperkecil (sebelumnya 80/120)
         bottom: this.isMobile ? 70 : 60
       },

       bar: { 
         groupWidth: '50%' // Lebar bar bisa disesuaikan
       },

       tooltip: { 
         isHtml: true,
         trigger: 'selection'
       },

       isStacked: false,
       
       // Opsional: Tambahkan padding
       width: '100%',
       height: this.isMobile ? 350 : 400
     };
   },
  
getChartOptions(title) {
  const isPieChart = ['Jenis Ternakan', 'Jantina', 'Baka', 'Jurusan', 'Status', 'Kaedah Penternakan', 'Jenis Pengguna', 'Jenis Baka'].includes(title);
  
  const options = {
    title: title,
    titleTextStyle: {
      fontSize: this.isMobile ? 16 : 18,
      bold: true
    },
    chartArea: { 
      width: this.isMobile ? '85%' : '85%',
      height: this.isMobile ? '75%' : '80%',
      top: 50,
      left: this.isMobile ? 10 : 20,
      right: 10,
      bottom: this.isMobile ? 50 : 40
    }
  };
  
  if (isPieChart) {
    Object.assign(options, {
      // Legend dengan custom formatter
      legend: { 
        position: this.isMobile ? 'bottom' : 'right',
        textStyle: {
          fontSize: this.isMobile ? 11 : 13, 
          maxLines: 3
        },
        alignment: 'center',
        // Format legend untuk tampilkan jumlah
        // Ini akan dipanggil untuk setiap item legend
      },
      // Tampilkan persentase di pie slice
      pieSliceText: 'percentage',
      pieSliceTextStyle: {
        fontSize: this.isMobile ? 11 : 13,
        color: 'white',
        bold: true
      },
      // Tooltip custom untuk tampilkan kedua informasi
      tooltip: {
        isHtml: true,
        trigger: 'focus',
        showColorCode: true
      },
      sliceVisibilityThreshold: 0.01,
      is3D: false,
      pieHole: 0.4,
      pieStartAngle: 15,
      backgroundColor: 'transparent',
      height: this.isMobile ? 250 : 320,
      width: '75%'
    });
  }
  
  return options;
},

  onChartReady(chart, google) {
  console.log('Chart ready - bisa diklik sekarang');
  
  // Optional: Tambahkan custom event listeners
  if (chart) {
    google.visualization.events.addListener(chart, 'select', () => {
      const selection = chart.getSelection();
      console.log('Chart selection from ready:', selection);
      this.onNegeriChartSelect(selection);
    });
  }
},
  onNegeriChartSelect(selection) {
  console.log('Chart select event:', selection); // Debug
  
  if (selection && selection.length > 0) {
    const selectedItem = selection[0];
    console.log('Selection details:', selectedItem); // Debug
    
    // Pastikan chartNegeri ada dan valid
    if (this.chartNegeri && this.chartNegeri.length > selectedItem.row + 1) {
      const selectedNegeriData = this.chartNegeri[selectedItem.row + 1];
      const selectedNegeri = selectedNegeriData[0];
      console.log('Selected Negeri:', selectedNegeri, 'Data:', selectedNegeriData); // Debug
      
      // Debug untuk melihat semua data negeri
      console.log('All negeri data:', this.chartNegeri);
      console.log('Original daerah data:', this.originalDaerahData);
      
      // Filter daerah berdasarkan negeri yang dipilih
      this.filterDaerahByNegeri(selectedNegeri);
    } else {
      console.log('Invalid selection or chart data');
      console.log('ChartNegeri length:', this.chartNegeri ? this.chartNegeri.length : 'undefined');
      console.log('Selected row:', selectedItem.row);
    }
  } else {
    console.log('No selection data - mungkin klik di area kosong');
  }
},

  filterDaerahByNegeri(negeriNama) {
  console.log('Filtering daerah for negeri:', negeriNama); // Debug
  
  if (!negeriNama || negeriNama === 'Tidak Diketahui' || negeriNama === 'Tiada Data') {
    // Tampilkan semua data jika tidak ada negeri yang dipilih
    this.filteredChartDaerah = [...this.originalChartDaerah];
    this.selectedNegeri = null;
    return;
  }

  // CASE-INSENSITIVE COMPARISON
  const negeriLower = negeriNama.toLowerCase().trim();
  
  // Filter data asli berdasarkan negeri (case-insensitive)
  const filteredData = this.originalDaerahData.filter(item => {
    const itemNegeriLower = item.negeri ? item.negeri.toLowerCase().trim() : '';
    console.log(`Comparing: "${itemNegeriLower}" with "${negeriLower}"`); // Debug
    return itemNegeriLower === negeriLower;
  });

  console.log('Filtered data count:', filteredData.length); // Debug
  console.log('Filtered data:', filteredData); // Debug

  if (filteredData.length === 0) {
    // Jika tidak ada data untuk negeri tersebut
    this.filteredChartDaerah = [['Daerah', 'Jumlah']];
    this.filteredChartDaerah.push(['Tiada Data untuk ' + negeriNama, 0]);
    this.selectedNegeri = negeriNama;
    return;
  }

  // Group by daerah dan hitung jumlah (case-insensitive untuk daerah juga)
  const daerahMap = {};
  filteredData.forEach(item => {
    const daerahKey = item.daerah ? item.daerah.toLowerCase().trim() : 'tidak-diketahui';
    daerahMap[daerahKey] = (daerahMap[daerahKey] || 0) + item.count;
  });

  console.log('Daerah map:', daerahMap); // Debug

  // Update chart daerah yang difilter
  this.filteredChartDaerah = [['Daerah', 'Jumlah']];
  Object.entries(daerahMap).forEach(([daerahKey, jumlah]) => {
    // Kembalikan ke format asli dengan capitalisasi
    const daerahAsli = filteredData.find(item => 
      item.daerah.toLowerCase().trim() === daerahKey
    )?.daerah || daerahKey;
    
    this.filteredChartDaerah.push([daerahAsli, jumlah]);
  });

  // Update selected negeri
  this.selectedNegeri = negeriNama;

  // Urutkan berdasarkan jumlah (descending)
  this.filteredChartDaerah = [
    this.filteredChartDaerah[0], // Header
    ...this.filteredChartDaerah.slice(1).sort((a, b) => b[1] - a[1])
  ];
  
  console.log('Final filteredChartDaerah:', this.filteredChartDaerah); // Debug
},
  // Method untuk reset filter
  resetDaerahFilter() {
    this.selectedNegeri = null;
    this.filteredChartDaerah = [...this.originalChartDaerah];
  },

  getColumnChartOptions(title, selectable = false) {
  const options = {
    title: title + (this.selectedNegeri ? ` (${this.selectedNegeri})` : ''),
    titleTextStyle: {
      fontSize: this.isMobile ? 16 : 20,
      bold: true
    },
    legend: { position: 'none' },
    hAxis: { 
      title: title,
      textStyle: {
        fontSize: this.isMobile ? 9 : 11,
        color: '#333'
      },
      slantedText: false, // Tetap lurus
      showTextEvery: 1,
      // Otomatis wrap berdasarkan panjang
      maxTextLines: 2, // Maksimal 2 baris
      allowContainerBoundaryTextCutoff: true,
      textPosition: 'out'
    }, 
    vAxis: { 
      title: 'Jumlah', 
      minValue: 0,
      format: '0',
      textStyle: {
        fontSize: this.isMobile ? 10 : 12
      },
      gridlines: {
        color: '#f0f0f0',
        count: 5
      }
    },
    chartArea: { 
      width: '85%',
      height: '70%',
      top: 50,
      left: 80,
      right: 20,
      bottom: 80 // Beri ruang lebih untuk label multi-baris
    },
    tooltip: { 
      isHtml: true,
      trigger: 'focus'
    },
    focusTarget: 'category',
    selectionMode: selectable ? 'single' : 'none',
    height: this.isMobile ? 450 : 550, // Tinggi lebih besar untuk label 2 baris
    animation: {
      startup: true,
      duration: 1000,
      easing: 'out'
    },
    enableInteractivity: true,
    bar: { 
      groupWidth: '50%'
    },
    isStacked: false,
    backgroundColor: 'transparent'
  };

  return options;
},

getUmurChartOptions() {
  return {
    title: 'Umur Ternakan',
    titleTextStyle: {
      fontSize: this.isMobile ? 14 : 16,
      bold: true
    },
    legend: { 
      position: this.isMobile ? 'bottom' : 'right',
      textStyle: {
        fontSize: this.isMobile ? 11 : 12
      }
    },
    vAxis: { 
      title: 'Jumlah',
      textStyle: {
        fontSize: this.isMobile ? 10 : 11
      },
      minValue: 0,
      format: '0' // Pastikan angka bulat
    },
    hAxis: { 
      title: 'Umur',
      textStyle: {
        fontSize: this.isMobile ? 10 : 11
      }
    },
    // Konfigurasi warna untuk jantan (biru) dan betina (merah)
    series: {
      0: { color: '#ef4444' }, // Biru untuk Jantan
      1: { color: '#3b82f6' }  // Merah untuk Betina
    },
    bar: { groupWidth: '60%' },
    isStacked: false, // Tampilkan side-by-side bars
    
    // Opsional: Tambahkan data labels di setiap bar
    annotations: {
      textStyle: {
        fontSize: this.isMobile ? 9 : 10,
        color: '#000'
      },
      alwaysOutside: false
    },
    
    chartArea: { 
      width: this.isMobile ? '85%' : '90%', 
      height: this.isMobile ? '60%' : '70%',
      top: 40,
      left: this.isMobile ? 40 : 60,
      right: 20,
      bottom: this.isMobile ? 60 : 40
    }
  };
}
},

// getPremis(){
//       this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
//         this.premis = res
//       })
//     },



  mounted() {
    this.getData(1);
    // this.getPremis();
    this.getNegeri();
    this.getServis();
    this.getAnak();
    this.getTarikhaiman();
    this.getTugasan();
    this.updateDateTime();
    this.getLkpTernakan();
    setInterval(this.updateDateTime, 1000);
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style scoped>



/* ===== LEGEND STYLES ===== */
.legend-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  max-height: 300px;
  overflow-y: auto;
  min-width: 180px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
}

.legend-color {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
}

.form-row {
  display: flex;
  gap: 16px; /* jarak kiri kanan */
}

.form-col {
  flex: 1; /* dua-dua sama lebar */
}


.legend-text {
  font-size: 14px;
  color: #374151;
  font-weight: 500;
}

/* Chart title untuk per-negeri */
.chart-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #1e293b;
  text-align: center;
  padding: 8px;
  background: linear-gradient(90deg, transparent, #f1f5f9, transparent);
}


.chart-row {
  display: flex;
  gap: 10px;              
  align-items: stretch;
}


.chart-left {
  flex: 4;                 
  min-width: 0;
}


.chart-right {
  flex: 0 0 180px;       
  min-width: 160px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 40px;
}


/* Responsive legend */
@media (max-width: 1024px) {
  .chart-row {
    flex-direction: column;
  }
  
  .chart-right {
    padding-top: 0;
    justify-content: flex-start;
  }
  
  .legend-container {
    max-height: 150px;
    min-width: auto;
  }
}

@media (max-width: 768px) {
  .legend-container {
    flex-direction: row;
    flex-wrap: wrap;
    max-height: none;
    padding: 8px;
  }
  
  .legend-item {
    flex: 0 0 calc(50% - 8px);
  }
  
  .legend-text {
    font-size: 12px;
  }
}

/* ===== DASHBOARD LAYOUT ===== */
.cards-table-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 24px;
  margin-top: 24px;
  align-items: start;
}

/* Styles untuk tabel premis */
.premis-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}

.premis-table th,
.premis-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
}

.premis-table th {
  background-color: #f8fafc;
  font-weight: 600;
  color: #374151;
}

.premis-table tr:hover {
  background-color: #f8fafc;
}

.jenis-pengguna-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
  padding: 4px 0;
}

.jenis-pengguna-item:last-child {
  margin-bottom: 0;
}

.jenis-badge {
  background: #3b82f6;
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  flex: 1;
  margin-right: 8px;
}

.jumlah-badge {
  background: #f1f5f9;
  color: #475569;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  min-width: 30px;
  text-align: center;
}


.text-center {
  text-align: center;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  margin-top: 20px;
}

.tables-stack {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.trend-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 20px;
  margin-top: 30px;
}

/* ===== CARD STYLES ===== */
.card-box {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 16px;
  padding: 24px 20px;
  box-shadow: 
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid #e2e8f0;
  position: relative;
  overflow: hidden;
  min-height: 120px;
  display: flex;
  align-items: center;
}

.card-box:hover {
  transform: translateY(-4px);
  box-shadow: 
    0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  border-color: #cbd5e0;
}

.card-box::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--card-color, #3b82f6), transparent);
}

.card-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
}

.card-text {
  flex: 1;
  min-width: 0;
}

.card-value {
  font-size: 32px;
  font-weight: 800;
  margin: 0 0 6px 0;
  color: #1a202c;
  line-height: 1;
  letter-spacing: -0.025em;
}

.card-subtitle {
  font-size: 14px;
  color: #64748b;
  display: block;
  font-weight: 500;
  line-height: 1.4;
  margin: 0;
}

.card-subtitle.with-highlight {
  position: relative;
  padding-bottom: 8px;
}

.card-subtitle.with-highlight::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  height: 3px;
  width: 40px;
  border-radius: 2px;
  background: var(--card-color, #3b82f6);
  transition: width 0.3s ease;
}

.card-box:hover .card-subtitle.with-highlight::after {
  width: 60px;
}

.card-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: var(--card-color, #3b82f6);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.card-box:hover .card-icon {
  transform: scale(1.05);
  box-shadow: 0 8px 15px -3px rgba(0, 0, 0, 0.2);
}

.card-icon .icon-img {
  width: 26px;
  height: 26px;
  object-fit: contain;
  filter: brightness(0) invert(1);
}

/* Card Colors */
.card-box:nth-child(1) { --card-color: #3b82f6; }
.card-box:nth-child(2) { --card-color: #10b981; }
.card-box:nth-child(3) { --card-color: #f59e0b; }
.card-box:nth-child(4) { --card-color: #ef4444; }
.card-box:nth-child(5) { --card-color: #8b5cf6; }
.card-box:nth-child(6) { --card-color: #ec4899; }
.card-box:nth-child(7) { --card-color: #06b6d4; }
.card-box:nth-child(8) { --card-color: #84cc16; }
.card-box:nth-child(9) { --card-color: #f97316; }
.card-box:nth-child(10) { --card-color: #64748b; }
.card-box:nth-child(11) { --card-color: #cc1616; }


/* ===== CHART STYLES ===== */
.chart-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px; /* Increased gap */
  margin-top: 20px; /* Increased margin */
  max-height: 75vh; /* Increased height */
  overflow-y: auto;
  padding-right: 8px;
}


/* Tambahkan di bagian CSS yang sudah ada */

/* Style untuk legend chart */
.google-visualization-tooltip {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.google-visualization-tooltip-item {
  padding: 4px 8px !important;
  font-size: 12px !important;
}

/* Custom legend dot colors */
.legend-color-box {
  border-radius: 4px !important;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
}

/* Responsive legend */
@media (max-width: 768px) {
  .google-visualization-tooltip {
    font-size: 11px !important;
    max-width: 200px !important;
  }
  
  .chart-box-full .google-visualization-chart {
    min-height: 350px !important;
  }
}

.chart-box {
  background: #fff;
  border-radius: 12px;
  padding: 20px; /* Increased padding */
  box-shadow: 0px 3px 8px rgba(0,0,0,0.1); /* Enhanced shadow */
  text-align: center;
  min-height: 320px; /* Increased minimum height */
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 1px solid #e2e8f0;
  position: relative;
}

.chart-box-full {
  grid-column: 1 / -1;
  background: #fff;
  border-radius: 12px;
  padding: 24px; /* Increased padding */
  box-shadow: 0px 3px 8px rgba(0,0,0,0.1);
  text-align: center;
  min-height: 380px; /* Increased minimum height */
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 1px solid #e2e8f0;
}


.chart-grid::-webkit-scrollbar {
  width: 6px;
}

.chart-grid::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.chart-grid::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.chart-grid::-webkit-scrollbar-thumb:hover {
  background: #555;
}


.trend-box {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0px 2px 6px rgba(0,0,0,0.1);
  border: 1px solid #e2e8f0;
}

/* ===== TABLE STYLES ===== */
.modern-table table {
  width: 100%;
  border-collapse: collapse;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  color: #333;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.table-header {
  background: linear-gradient(90deg, #3b82f6, #2563eb) !important;
  color: white !important;
}

.table-header th {
  background: linear-gradient(90deg, #3b82f6, #2563eb) !important;
  color: white !important;
  padding: 14px 16px !important;
  border: none !important;
}

.header-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-align: center;
}

.header-column .title {
  font-size: 16px;
  font-weight: 600;
}

.header-column .datetime {
  font-size: 13px;
  font-weight: 400;
  opacity: 0.9;
}

.table-subheader {
  background: #f8fafc;
  font-weight: 500;
  color: #475569;
}

.table-subheader th {
  padding: 12px;
  border-bottom: 1px solid #e2e8f0;
}

tbody td {
  padding: 12px;
  border-bottom: 1px solid #f1f5f9;
}

tbody tr:hover {
  background: #f8fafc;
}

/* User table styling */
.table-container {
  max-height: 400px;
  overflow-y: auto;
  margin-top: 10px;
}

.user-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}

.user-table th,
.user-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
}

.user-table th {
  background-color: #f8fafc;
  font-weight: 600;
  color: #374151;
}

.user-table tr:hover {
  background-color: #f8fafc;
}

.role-badge {
  display: inline-block;
  background: #3b82f6;
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  margin: 2px;
  font-weight: 500;
}

/* ===== BUTTON STYLES ===== */
.btn-modern {
  background: linear-gradient(135deg, #4f46e5, #3b82f6);
  color: white;
  border: none;
  border-radius: 9999px;
  padding: 8px 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
  font-size: 13px;
}

.btn-modern:hover {
  background: linear-gradient(135deg, #4338ca, #2563eb);
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

.btn-modern:active {
  transform: scale(0.95);
}

.reset-btn {
  font-size: 11px !important;
  padding: 4px 10px !important;
}

/* ===== DIALOG STYLES ===== */
.dialog-content-custom {
  padding: 24px !important; /* Increased padding */
  max-height: 90vh !important; /* Increased max height */
  overflow-y: auto !important;
}

/* Tambahkan class khusus untuk dialog dengan chart */
.w-dialog--fullscreen {
  background: white;
}

.w-dialog__content {
  display: flex;
  flex-direction: column;
}

/* Styling untuk chart container */
.chart-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* Full height untuk Google Chart */
.google-visualization-chart {
  flex: 1;
  min-height: 300px;
}


.selected-negeri {
  font-size: 14px;
  opacity: 0.8;
  font-weight: normal;
  margin-left: 8px;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding: 0 8px;
}

/* ===== CHART LEGEND STYLES ===== */
.chart-umur-legend {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 12px;
  padding: 8px;
}

.legend-dot-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.dot {
  font-size: 16px;
}

.female-dot {
  color: #3b82f6;
}

.male-dot {
  color: #ef4444;
}

.legend-label {
  font-size: 14px;
  color: #374151;
  font-weight: 500;
}

.selectable-chart {
  cursor: pointer;
}

.selectable-chart:hover {
  opacity: 0.9;
}

/* Tambahkan di bagian CSS yang sudah ada */
.role-text {
  font-size: 14px;
  color: #374151;
  line-height: 1.4;
  display: inline-block;
  padding: 4px 8px;
  background: #f8fafc;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
}

/* Untuk tabel yang lebih kompak di dalam chart box */
.chart-box .table-container {
  max-height: 200px;
  overflow-y: auto;
}

.chart-box .user-table {
  font-size: 12px;
}

.chart-box .user-table th,
.chart-box .user-table td {
  padding: 8px;
}

/* ===== RESPONSIVE DESIGN ===== */
@media (max-width: 1024px) {
  .cards-table-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .dashboard-grid {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 14px;
  }
  
  .card-box {
    padding: 20px 16px;
    min-height: 110px;
  }
  
  .card-value {
    font-size: 28px;
  }
  
  .card-icon {
    width: 50px;
    height: 50px;
  }
  
  .card-icon .icon-img {
    width: 24px;
    height: 24px;
  }
  
  .chart-box {
    min-height: 260px;
  }
  
  .chart-box-full {
    min-height: 300px;
  }
}

@media (max-width: 768px) {
  .dashboard-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .trend-grid {
    grid-template-columns: 1fr;
  }
  
  .chart-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .chart-grid-mobile .chart-box {
    min-height: 240px;
  }
  
  .chart-grid-mobile .chart-box-full {
    min-height: 280px;
  }
  
  .card-box {
    padding: 18px 14px;
    min-height: 100px;
  }
  
  .card-value {
    font-size: 26px;
  }
  
  .card-subtitle {
    font-size: 13px;
  }
  
  .card-icon {
    width: 44px;
    height: 44px;
  }
  
  .card-icon .icon-img {
    width: 22px;
    height: 22px;
  }
  
  .chart-umur-legend {
    gap: 15px;
  }
  
  .legend-dot-item {
    gap: 4px;
  }
  
  .dot {
    font-size: 14px;
  }
  
  .legend-label {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .card-content {
    gap: 12px;
  }
  
  .card-box {
    padding: 16px 12px;
    min-height: 90px;
  }
  
  .card-value {
    font-size: 24px;
  }
  
  .card-icon {
    width: 40px;
    height: 40px;
  }
  
  .card-icon .icon-img {
    width: 20px;
    height: 20px;
  }
  
  .trend-grid {
    gap: 16px;
    margin-top: 24px;
  }
  
  .trend-box {
    padding: 16px;
  }
}

/* Tablet landscape adjustments */
@media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .table_scrol {
    max-height: 85vh;
    overflow-y: auto;
  }
  
  .card-box {
    padding: 16px 12px;
    min-height: 90px;
  }
  
  .card-value {
    font-size: 26px;
  }
  
  .chart-box {
    padding: 12px;
    min-height: 220px;
  }
  
  .chart-box-full {
    padding: 12px;
    min-height: 260px;
  }
  
  .trend-box {
    padding: 16px;
    min-height: 240px;
  }
}

/* Animation for card appearance */
@keyframes cardAppear {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card-box {
  animation: cardAppear 0.5s ease-out forwards;
}

/* Stagger animation for multiple cards */
.card-box:nth-child(1) { animation-delay: 0.1s; }
.card-box:nth-child(2) { animation-delay: 0.2s; }
.card-box:nth-child(3) { animation-delay: 0.3s; }
.card-box:nth-child(4) { animation-delay: 0.4s; }
.card-box:nth-child(5) { animation-delay: 0.5s; }
.card-box:nth-child(6) { animation-delay: 0.6s; }
.card-box:nth-child(7) { animation-delay: 0.7s; }
.card-box:nth-child(8) { animation-delay: 0.8s; }
.card-box:nth-child(9) { animation-delay: 0.9s; }
.card-box:nth-child(10) { animation-delay: 1s; }
.card-box:nth-child(11) { animation-delay: 1.1s; }

</style>